export default __webpack_public_path__ + "static/media/lengthy.cc04e1fe.svg";